export default {
  description: [
    {
      rule: 'notempty',
      parameters: [],
    },
    {
      rule: 'maxlengthequal',
      parameters: ['170'],
    },
  ],
  seasons: [],
  name: [
    {
      rule: 'notempty',
      parameters: [],
    },
    {
      rule: 'maxlengthequal',
      parameters: ['50'],
    },
  ],
  casting: [],
  titleMediaUrl: [
    {
      rule: 'notempty',
      parameters: [],
    },
  ],
  titleMediaImageUrl: [
    {
      rule: 'notempty',
      parameters: [],
    },
  ],
  releaseDate: [],
  owner: [],
  id: [],
  created: [],
  updated: [],
  deleted: [],
  version: [],
  mediaStatus: [
    {
      rule: 'oneof',
      parameters: ['MediaStatus'],
    },
  ],
  titleTransparentUrl: [
    {
      rule: 'notempty',
      parameters: [],
    },
  ],
  genre: [],
  tags: [],
  titleMediaImageLocation: [],
  titleMediaLocation: [],
  titleTransparentLocation: [],
  hasProcessed: [],
  rating: [
    {
      rule: 'oneof',
      parameters: ['Rating'],
    },
  ],
}
